




















































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Components from '@/tenantCatalog/components';
import * as Common from '@/tenantCatalog/common';
import { TenantCatalogCancelQuery } from '../models/All';

@Component
export default class CategoryView extends Vue {
  public items: Common.Tenant[] = new Array(0);
  public params: Common.TenantQuery = new Common.TenantQuery();
  public exportQuery = new Common.ExportQuery('テナント', this.params);
  public sortOptions: any = [{ value: 'elapsedWeek', text: '経過週' },{ value: 'id', text: 'テナントID' },{ value: 'name', text: 'テナント名称' },{ value: 'databaseName', text: '接続先DB' },{ value: 'roadmapRate', text: 'ロードマップ' },{ value: 'trialExpiry2', text: 'トライアル期限' },{ value: 'cohortWeek', text: 'サインアップ週' }];

  public dialogBilling: boolean = false;
  public closingDate : Date = null;

  @Prop() public tenantId:string;

  public created(){
    if (this.tenantId) this.params.id = this.tenantId; 
    else {
      this.params.paymentStatus = Common.paymentStatusFlags.Trial;
      this.params.sort = "elapsedWeek";
      this.params.isDescending = true;
    }
    this.$api.formatter.ensureListLoaded('tenantList','shipmentFlags').then(()=>this.$forceUpdate());
  }

  
  //テナントに遷移
  public onClick(tenant:Common.Tenant, licenseFlag:Common.licenseFlags){        
    if (this.$api.enviromentFlag == Common.enviromentFlags.production) {
      if((tenant.licenseFlag & Common.licenseFlags.prime) != 0)
        // サーバー専有プラン
        window.open(String.format("https://{0}.s-flow-prime.net",tenant.id), '_blank');
      else
        // 通常プラン
        window.open(String.format("https://{0}.s-flow.net",tenant.id), '_blank');       
    }
    else 
    {
      if((tenant.licenseFlag & Common.licenseFlags.prime) != 0)
        window.open(String.format("https://{0}.s-flow-prime-stage.net",tenant.id), '_blank');
      else
        window.open(String.format("https://{0}.s-flow-stage.net",tenant.id), '_blank');
    }
  }
  public showDialog(){

    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('請求処理','対象のテナントを選択してください。',true,null);
       return;
     } else if (items.filter(obj =>obj.paymentStatus != Common.paymentStatusFlags.Paid && obj.paymentStatus != Common.paymentStatusFlags.Cancelled ).length > 0) {
       this.$api.modal.show('請求処理','有償利用中もしくは解約済みのテナント以外は選択できません。',true,null);
       return;
    }


    //前月末日をセット
    var date1 = new Date().getCalendarDate();
    date1 = new Date(date1.getFullYear(),date1.getMonth(),1);
    date1.setDate(date1.getDate() -1);
    this.closingDate = date1;

    this.dialogBilling = true;
  }

  public getSelectedItems() : Common.Tenant[]{
    return  (this.$refs.mainList as Components.ListView).selectedItems as Common.Tenant[];    
  }

  public executeBilling(){

    //請求締処理を実行する
    var query = new Common.MonthCloseQuery(this.getSelectedItems());
    query.closingDate = this.closingDate;
    this.$api.execute(query).then(res=>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','バッチ処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);                    
    });    
  }



  public executeTrialClose(){

    var today = new Date();
    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('トライアル解約処理','対象のテナントを選択してください。',true,null);
       return;
    }
    else if (items.filter(obj =>obj.paymentStatus != Common.paymentStatusFlags.Trial || obj.trialExpiry > today).length > 0) {
       this.$api.modal.show('トライアル解約処理','トライアル期限切れのテナント以外は選択できません。',true,null);
       return;
    }

    this.$api.modal.showDialog('トライアル解約処理','トライアル版の解約処理を実施してよろしいですか?',false).then(()=>{
      this.$api.execute(new Common.TrialCloseQuery(items)).then(res=>{
          var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
          this.$api.modal.show('処理結果','バッチ処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);                    
        });    
    });
  }

  public showSubscriptions(tenantId:string){
      this.$router.push(String.format('/project/subscription?tenantId={0}',tenantId));
  }  
  public showBillings(tenantId:string){
      this.$router.push(String.format('/project/billing?tenantId={0}',tenantId));
  }    

  // 解約処理
  public showTenantCancelDialog(){
    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('強制解約処理','対象のテナントを選択してください。',true,null);
       return;
    }else if (items.length != 1) {
       this.$api.modal.show('強制解約処理','単一のテナントを選択してください。',true,null);
       return;
    }

    const tenant = items[0];
    if(tenant.paymentStatus != Common.paymentStatusFlags.Paid){
      this.$api.modal.show('強制解約処理','有償利用テナント以外は選択できません。',true,null);
      return;
    }
    this.$api.modal.showDialog('確認メッセージ',String.format('テナント {0} の強制解約処理を実行しますか？',tenant.id), false).then(()=>{
          this.$api.execute(new TenantCatalogCancelQuery(tenant)).then(()=>this.$api.modal.showDialog('メッセージ','テナントの解約が完了しました。'));
    });
  }      

  public dialogPartner: boolean = false;
  public dueDate : Date = null;
  public showPartnerDialog(){

    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('パートナー処理','対象のパートナーを選択してください。',true,null);
       return;
     } else if (items.filter(obj =>obj.isPartner == false ).length > 0) {
       this.$api.modal.show('パートナー処理','パートナー以外は選択できません。',true,null);
       return;
    }

    //月末日をセット
    var date1 = new Date().getCalendarDate();
    date1 = new Date(date1.getFullYear(),date1.getMonth(),1);
    date1.setMonth(date1.getMonth() + 1);
    date1.setDate(date1.getDate() -1);
    this.dueDate = date1;

    this.dialogPartner = true;
  }
  public executePartner(){

    //請求締処理を実行する
    var query = new Common.PartnerPaymentProcessQuery(this.getSelectedItems());
    query.dueDate = this.dueDate;
    this.$api.execute(query).then(res=>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','バッチ処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);                    
    });    
  }


  public showMFADialog(){
    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('2段階認証の有効化','対象のテナントを選択してください。',true,null);
       return;
     } else if (items.filter(obj =>obj.mfaEnabled).length > 0) {
       this.$api.modal.show('2段階認証の有効化','有効化済みのテナントは選択できません。',true,null);
       return;
    }

    this.$api.modal.showDialog('2段階認証の有効化','2段階認証は一度有効化すると元に戻せません。有効化してよろしいですか？').then(()=>{
        this.$api.execute(new Common.EnableMFAQuery(items)).then(()=>{
          this.$api.modal.show('処理結果','2段階認証を有効化しました。',true,null);   
        });
    });
  }

  public showObjectMigration(){

    const items = this.getSelectedItems();
    if (items.filter(obj =>obj.paymentStatus != Common.paymentStatusFlags.Paid && obj.paymentStatus != Common.paymentStatusFlags.Trial ).length > 0) {
       this.$api.modal.show('マイグレーション','有償利用中もしくはトライアル利用中のテナントを選択してください。',true,null);
       return;
    }

    if (items.length == 0) {
       this.$api.modal.showDialog('マイグレーション','利用中の全てのテナントのマイグレーションを開始してよろしいですか？',false,null).then(()=>{
         this.$api.execute(new Common.ObjectMigrationExecuteQuery(null));
       });
       return;
     } else {
       this.$api.modal.showDialog('マイグレーション','選択されたテナントのマイグレーションを開始してよろしいですか？',false,null).then(()=>{
         this.$api.execute(new Common.ObjectMigrationExecuteQuery(items));
       });       
     }

  }  

  public dialogChangeLicenseFlag:boolean = false;
  public changeDbFlag:boolean = false;
  public changeDbName:string = null;
  public changeLicenseFlag:Common.licenseFlags = null;
  public telNo: string = "";
  public updateInitialAmountFlag:boolean = false;
  public showChangeLicenseFlagDialog(){
    this.changeDbFlag = false;
    this.changeDbName = null;
    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('利用プラン変更','利用プランを変更したいテナントを選択してください。',true,null);
       return;
    } else if (items.length > 1) {
       this.$api.modal.show('利用プラン変更','同時に複数テナントの利用プランを変更することはできません。',true,null);
       return;      
    } else if (items[0].licenseFlag < Common.licenseFlags.professional) {
      //  this.$api.modal.show('利用プラン変更','このテナントは利用プランを変更できません。',true,null);
      // return;      
      this.changeDbFlag = true; // プロフェッショナル⇔サーバー専有以外の場合DBの更新ができる必要がある
    }
    this.changeLicenseFlag = items[0].licenseFlag;
    this.telNo = items[0].telNo;
    this.dialogChangeLicenseFlag = true;
  }

  public dialogTransfer:boolean = false;
  public targetDbName:string = '';
  public showTransferDialog(){
    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('テナントDB移行処理','DBを移行したいテナントを選択してください。',true,null);
       return;
    } else if (items.filter(obj =>obj.databaseName != items[0].databaseName).length > 0) {
       this.$api.modal.show('テナントDB移行処理','同一の移行元DBに配置されたテナントを選択してください。',true,null);
       return;      
    }
    this.targetDbName = '';
    this.dialogTransfer = true;
  }

  // 電話番号のテキストボックスのバリデーションを走らせるために追加
  public executeChangeLicenseFlag(event :any){
    if ((this.$refs.changeLicenseFlag as Components.ComboBox).validator.validate() == false || (this.$refs.telNo as Components.TextBox).validator.validate() == false || (this.changeDbFlag && ((this.$refs.changeDbName as Components.TextBox).validator.validate() == false))) {
      event.preventDefault();
      return;
    }
    const items = this.getSelectedItems();
    this.$api.execute(new Common.ChangeLicenseFlagQuery(items,this.changeLicenseFlag, this.telNo, this.updateInitialAmountFlag, this.changeDbName)).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','バッチ処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);           
    });
  }

  public executeTransfer(event :any){
    if ((this.$refs.targetDbName as Components.TextBox).validator.validate() == false) {
      event.preventDefault();
      return;
    }    
    const items = this.getSelectedItems();
    this.$api.execute(new Common.TransferTenantQuery(items,this.targetDbName)).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','バッチ処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);           
    });
  }

  public safeIntroductionPackExpiry: Date = null;
  public dialogChangeSafeIntroductionPackExpiry:boolean = false;
  public showChangeSafeIntroductionPackExpiryDialog(){
    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('導入パック有効期限更新','対象のテナントを選択してください。',true,null);
       return;
    }
    else if (items.length != 1) {
       this.$api.modal.show('導入パック有効期限更新','単一のテナントを選択してください。',true,null);
       return;
    }
    this.safeIntroductionPackExpiry = items[0].safeIntroducsionPackExpiry;
    this.dialogChangeSafeIntroductionPackExpiry = true;
  }

  // あんしん導入パック有効期限延長処理
  public executeChangeSafeIntroductionPackExpiry(event: any){
    const items = this.getSelectedItems();
    this.$api.execute(new Common.ChangeSafeIntroductionPackExpiryQuery(items[0], this.safeIntroductionPackExpiry));
  }
  
  public showRetrialDialog(){
    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('再トライアル許可','対象のテナントを選択してください。',true,null);
       return;
     } else if (items.length > 1) {
       this.$api.modal.show('再トライアル許可','単一のテナントを選択してください。',true,null);
       return;
     } else if (items.filter(obj => obj.paymentStatus != 2 && obj.paymentStatus != 3).length > 0) {
       this.$api.modal.show('再トライアル許可','解約済みテナント以外は選択できません。',true,null);
       return;
     } else if (items.filter(obj =>obj.retrialPossible).length > 0) {
       this.$api.modal.show('再トライアル許可','再トライアル許可済みのテナントは選択できません。',true,null);
       return;
    }

    this.$api.modal.showDialog('再トライアル許可',String.format('テナント [{0}] の再トライアルを許可します。よろしいですか？',items[0].name)).then(()=>{
        this.$api.execute(new Common.EnableRetrialQuery(items[0])).then(()=>{
          this.$api.modal.show('処理結果','再トライアル許可を設定しました。',true,null);   
          (this.$refs.mainList as Components.ListView).reload();
        });
    });
  }
  
  public paymentDialog = false;
  public subscriberCode:string;
  public firstDeductionMonth:Date=new Date();
  public showPaymentDialog(){
    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('有償登録設定(口座振替)','対象のテナントを選択してください。',true,null);
       return;
     } else if (items.length > 1) {
       this.$api.modal.show('有償登録設定(口座振替)','単一のテナントを選択してください。',true,null);
       return;
     } else if (items[0].paymentAgent == Common.paymentAgentFlags.payJp) {
       this.$api.modal.show('有償登録設定(口座振替)','payJpから口座振替への変更はできません。',true,null);
       return;
     } else if((items[0].licenseFlag & Common.licenseFlags.prime) == 0) {
       this.$api.modal.show('有償登録設定(口座振替)','ライトプランのテナントは選択できません。',true,null);
       return;
    }
    //翌月1日をセット
    var date1 = new Date().getCalendarDate();
    date1 = new Date(date1.getFullYear(),date1.getMonth(),1);
    date1.setMonth(date1.getMonth()+1);
    this.firstDeductionMonth = date1;
    this.paymentDialog = true;
  }
  public executePayment(event :any){
    // if ((this.$refs.subscriberCode as Components.TextBox).validator.validate() == false || ((this.$refs.firstDeductionMonth as Components.Calendar).validator.validate() == false)) {
    //   event.preventDefault();
    //   return;
    // }

    const items = this.getSelectedItems();
    this.$api.execute(new Common.ExecutePaymentQuery(items[0], this.subscriberCode, this.firstDeductionMonth)).then(()=>{
      this.$api.modal.show('処理結果','有償利用設定を行いました',true,null);   
      (this.$refs.mainList as Components.ListView).reload();
    });
  }
}
